import {ansiToJson} from 'anser'
import * as React from 'react'
import type {CSSProperties} from 'react'

import {ansiRegexpString} from '../../../../BuildLog.utils'
import LinkText from '../LinkText/LinkText'

type Props = {
  children: string
  parseLinks?: boolean | null | undefined
}
export default function AnsiText({children, parseLinks}: Props) {
  const formattedText = children.replace(new RegExp(ansiRegexpString, 'gi'), '\u001b$1')
  const chunks = ansiToJson(formattedText)

  if (chunks.length === 1 && !chunks[0].was_processed) {
    return parseLinks === true ? <LinkText>{children}</LinkText> : <>{children}</>
  }

  return (
    <>
      {chunks.map((jsonChunk, index) => {
        const style: CSSProperties = {}

        if (jsonChunk.bg != null) {
          style.backgroundColor = `rgb(${jsonChunk.bg})`
        }

        if (jsonChunk.fg != null) {
          style.color = `rgb(${jsonChunk.fg})`
        }

        if (jsonChunk.decoration != null) {
          switch (jsonChunk.decoration) {
            case 'bold':
              style.fontWeight = 'bold'
              break

            case 'dim':
              style.opacity = '0.5'
              break

            case 'italic':
              style.fontStyle = 'italic'
              break

            case 'reverse': {
              const color = style.color
              style.color =
                style.backgroundColor ??
                (color != null ? 'var(--ring-content-background-color)' : undefined)
              style.backgroundColor = color
              break
            }

            case 'hidden':
              style.visibility = 'hidden'
              break

            case 'strikethrough':
              style.textDecoration = 'line-through'
              break

            default:
              style.textDecoration = jsonChunk.decoration
              break
          }
        }

        return (
          // eslint-disable-next-line react/no-array-index-key
          <span key={index} style={style}>
            {parseLinks === true ? <LinkText>{jsonChunk.content}</LinkText> : jsonChunk.content}
          </span>
        )
      })}
    </>
  )
}
